<div class="content-box">
    <app-input-buscar></app-input-buscar>


  <section #listaCategorias class="categoria-servicos-pagina" aria-labelledby="categoria-servicos-pagina-titulo">

    <app-breadcrumb pagina="Categorias de serviços"></app-breadcrumb>

    <div class="categoria-servicos-cabecalho">
      <h1 class="categoria-servicos-pagina-titulo" id="categoria-servicos-pagina-titulo">
        Todas as categorias de serviços
      </h1>

      <div class="categoria-servicos-busca">
        <i-lucide class="categoria-servicos-busca-icone" name="search" size="18" aria-hidden="true"></i-lucide>

        <label class="categoria-servicos-busca-label" for="categoria-servicos-busca">
          Buscar por categoria
        </label>
        <input id="categoria-servicos-busca" class="categoria-servicos-busca-input" type="search" autocomplete="off"
          placeholder="Buscar por categoria" [value]="termoBusca()"
          (input)="aoBuscar($event)" />

        @if (termoBusca()) {
        <button type="button" class="categoria-servicos-busca-limpar" (click)="limparBusca()" aria-label="Limpar busca">
          <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
        </button>
        }
      </div>
    </div>

    @if (categorias().length && !falhou()) {
    <div class="categoria-servicos-filtros">
      <div class="categoria-servicos-filtro">
        <span class="categoria-servicos-filtros-rotulo" id="categoria-servicos-filtro-categorias">
          Filtrar por categoria
        </span>

        <div class="categoria-servicos-select" #selectCategorias>
          <button #selectCategoriasControle type="button" class="categoria-servicos-select-controle"
            [class.categoria-servicos-select-controle-ativo]="categoriasSelecionadas().size > 0"
            [attr.aria-expanded]="selectCategoriasAberto()" aria-haspopup="true"
            aria-controls="categoria-servicos-select-opcoes"
            aria-labelledby="categoria-servicos-filtro-categorias categoria-servicos-select-valor"
            (click)="alternarSelectCategorias()">
            <span class="categoria-servicos-select-valor" id="categoria-servicos-select-valor">
              {{ resumoCategorias() }}
            </span>
            <i-lucide class="categoria-servicos-select-seta" name="chevron-down" size="18"
              aria-hidden="true"></i-lucide>
          </button>

          @if (selectCategoriasAberto()) {
          <div class="categoria-servicos-select-opcoes" id="categoria-servicos-select-opcoes" role="group"
            aria-labelledby="categoria-servicos-filtro-categorias">
            @for (categoria of categorias(); track categoria.id) {
            <label class="categoria-servicos-select-opcao" [attr.data-categoria-servicos-cor]="categoria.cor">
              <input type="checkbox" class="categoria-servicos-select-check"
                [attr.aria-label]="rotuloOpcaoCategoria(categoria)"
                [checked]="categoriaSelecionada(categoria.id)" (change)="alternarCategoria(categoria.id)" />
              <span class="categoria-servicos-select-ponto" aria-hidden="true"></span>
              <span class="categoria-servicos-select-rotulo">{{ categoria.titulo }}</span>
              <span class="categoria-servicos-select-total">{{ categoria.totalServicos }}</span>
            </label>
            }

            <button type="button" class="categoria-servicos-select-limpar"
              [disabled]="!categoriasSelecionadas().size" (click)="limparCategorias()">
              Limpar seleção
            </button>
          </div>
          }
        </div>
      </div>

      <div class="categoria-servicos-filtro">
        <span class="categoria-servicos-filtros-rotulo" id="categoria-servicos-filtro-tipos">
          Filtrar por tipo
        </span>

        <div class="categoria-servicos-filtros-badges" role="group" aria-labelledby="categoria-servicos-filtro-tipos">
          <button type="button" class="categoria-servicos-badge categoria-servicos-badge-tipo"
            [class.categoria-servicos-badge-ativa]="!tiposSelecionados().size"
            [attr.aria-pressed]="!tiposSelecionados().size" (click)="limparTipos()">
            Todos
          </button>

          @for (opcao of tiposCategoriaServicos(); track opcao.tipo) {
          <button type="button" class="categoria-servicos-badge categoria-servicos-badge-tipo"
            [class.categoria-servicos-badge-ativa]="tipoSelecionado(opcao.tipo)"
            [attr.aria-pressed]="tipoSelecionado(opcao.tipo)" (click)="alternarTipo(opcao.tipo)">
            <i-lucide [name]="opcao.icone" size="15" aria-hidden="true"></i-lucide>
            {{ opcao.rotuloFiltro }}
            <span class="categoria-servicos-badge-total">{{ totalDoTipo(opcao.tipo) }}</span>
          </button>
          }
        </div>
      </div>
    </div>
    }

    <!-- Região viva única: fica sempre no DOM para o leitor de tela anunciar a troca de estado. -->
    <p class="categoria-servicos-resultado" role="status" aria-live="polite">
      @if (carregando()) {
      Carregando as categorias de serviços...
      } @else if (categorias().length && !falhou()) {
      {{ totalResultados() }}
      {{ totalResultados() === 1 ? 'categoria encontrada' : 'categorias encontradas' }}
      }
    </p>

    @if (falhou()) {
    <div class="categoria-servicos-vazio" role="alert">
      <p class="categoria-servicos-vazio-texto">
        Não foi possível carregar as categorias de serviços agora. Tente novamente em instantes.
      </p>

      <button type="button" class="categoria-servicos-vazio-botao" (click)="recarregar()">
        Tentar novamente
      </button>
    </div>
    } @else if (semCatalogo()) {
    <div class="categoria-servicos-vazio">
      <p class="categoria-servicos-vazio-texto">Nenhuma categoria de serviço publicada até o momento.</p>
    </div>
    } @else if (categorias().length) {
    @if (categoriasDaPagina().length) {
    <div class="categoria-servicos-grade">
      @for (categoria of categoriasDaPagina(); track categoria.id) {
      <app-page-categoria-servicos-card [categoria]="categoria"></app-page-categoria-servicos-card>
      }

      <app-links-dinamicos local="Todos os Serviços" [exibir]="paginaAtual() === 1"></app-links-dinamicos>
    </div>
    } @else {
    <div class="categoria-servicos-vazio">
      <p class="categoria-servicos-vazio-texto">
        Nenhuma categoria encontrada para a busca ou os filtros selecionados.
      </p>

      @if (temFiltroAtivo()) {
      <button type="button" class="categoria-servicos-vazio-botao" (click)="limparTudo()">
        Limpar busca e filtros
      </button>
      }
    </div>
    }

    @if (totalPaginas() > 1) {
    <app-paginacao rotulo="Paginação das categorias de serviços" [paginaAtual]="paginaAtual()"
      [totalPaginas]="totalPaginas()" (paginaMudou)="irParaPagina($event)"></app-paginacao>
    }
    }
  </section>
</div>
